<template>
  <textarea 
    rows="4"
    :value="value"
    @input="e => $emit('input', e.target.value)"
    :placeholder="$t('create_preorder.comment_ph')"
    class="creation-comment-textarea"></textarea>
</template>

<script>
export default {
    props: {
        value: String
    }
}
</script>

<style scoped>
.creation-comment-textarea {
    width: 100%;
    color: #1d1d1b;
    background: transparent;
    outline: none;
    border: 1px solid #a4a3a1;

    padding: 1.2vh;

    border-radius: 1.2vh;
}

.creation-comment-textarea::placeholder {
    color: #908f8d;
}
</style>